import { applyMiddleware, compose } from 'redux'
import * as auth from 'js/redux/api/auth'
import { withExtraArgument } from 'redux-thunk'

export const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default composeEnhancers(
  applyMiddleware(
    withExtraArgument({
      auth
    })
  )
)
